import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Header.css';

const Header = ({ scrolled, isHome }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const closeMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <header className={`header ${(!scrolled && isHome) ? 'header-transparent' : 'header-scrolled'}`}>
      <nav className="nav-container">
        <Link to="/" className="logo" onClick={closeMenu}>
          <img
            src="/images/logo2.png"
            alt="Ecolimpieza Perú A&G"
            className="logo-image"
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.nextElementSibling.style.display = 'flex';
            }}
          />
          <div className="logo-brand-name">
            <span className="logo-brand-eco">Ecolimpieza</span>
            <span className="logo-brand-peru"> Perú</span>
            <span className="logo-brand-sac">A&amp;G S.A.C.</span>
          </div>
          <div className="logo-text-fallback">
            <div className="logo-text">
              <span className="logo-eco">Ecolimpieza</span>
              <span className="logo-peru"> Perú</span>
            </div>
            <div className="logo-sac">A&amp;G S.A.C.</div>
          </div>
        </Link>

        <ul className={`nav-links ${mobileMenuOpen ? 'mobile-active' : ''}`}>
          <li><Link to="/" onClick={closeMenu}>Inicio</Link></li>

          <li className="dropdown">
            <Link to="/servicios" onClick={closeMenu}>
              Servicios <span className="dropdown-arrow">▼</span>
            </Link>
            <ul className="dropdown-menu">
              <li><Link to="/servicios/limpieza" onClick={closeMenu}>Limpieza</Link></li>
              <li><Link to="/servicios/auxiliares" onClick={closeMenu}>Servicios Auxiliares</Link></li>
              <li><Link to="/servicios/mantenimiento" onClick={closeMenu}>Mantenimiento e Ingeniería</Link></li>
              <li><Link to="/servicios/rrhh" onClick={closeMenu}>Recursos Humanos</Link></li>
              <li><Link to="/servicios/sociosanitarios" onClick={closeMenu}>Servicios Sociosanitarios</Link></li>
              <li><Link to="/servicios/soluciones-integrales" onClick={closeMenu}>Soluciones Integrales</Link></li>
            </ul>
          </li>

          <li><Link to="/nosotros" onClick={closeMenu}>Nosotros</Link></li>
          <li><Link to="/contacto" onClick={closeMenu}>Contacto</Link></li>
          <li>
            <Link to="/contacto" onClick={closeMenu} className="cta-button">
              Solicitar Cotización
            </Link>
          </li>
        </ul>

        <button
          className="mobile-menu-btn"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? '✕' : '☰'}
        </button>
      </nav>
    </header>
  );
};

export default Header;
